import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";

export class ShipperAccountLinkTooltipCtrl implements IController {
  account: AccountModel;
  user: any;
  isShowCopyButton: boolean;
  isShowFilterByButton: boolean;
  onFilterByType: Function;

  public isShowAccountActions: boolean;
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;

  constructor() {

  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountLinkTooltip', {
    bindings: {
      account: '<',
      user: '<?',
      isShowCopyButton: '<?',
      isShowFilterByButton: '<?',
      onFilterByType: '&'
    },
    template: require('./shipper-account-link-tooltip.html').default,
    controller: ShipperAccountLinkTooltipCtrl
  });

